import classes from "./FourStep.module.scss";
import body from "../../../index.module.scss";
import PinkBg from "../../PinkBlock/PinkBlock";
import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import Cards from '../../Cards/Cards';
import Result from './Result/Result';
import Thanks from './Thanks/Thanks';

const data = [
  {
    number: "01.",
    title: "До нас над сайтом\n работали 3 различные\n студии по технической поддержке.",
    text: ""
  },
  {
    number: "02.",
    title: "В процессе доработки на сайте было внесено\n огромное количество изменений,",
    text: "что привело к деунификации программного кода и появлению множества «костылей», усложняющих разработку."
  },
  {
    number: "03.",
    title: "Сайт стал сложным на столько, что выполнение некоторых рекомендаций по SEO было крайне затруднительно.",
    text: "Например, рефакторинг кода с целью ускорения сайта вел к значительной переработке сайта."
  },
  {
    number: "04.",
    title: "Модифицированное ядро\n CMS Bitrix сделало очень\n трудозатратным создание\n турбо-страниц по\n технологии Яндекс\n и AMP-страниц по\n технологии Google.",
    text: ""
  },
]

const FourStep = ()=> {
  return (
    <section id="Nuances" className={classes.FourStep}>
      <PinkBg
         number={"4"}
         customClass={classes.PinkBg}
         CustomNumClass={classes.Number}
         />
      <div className={body.container}>
        <div className={classes.Wrap}>
        <SectionTitle
           customClass={classes.Title}
           text={"нюансы\n ПРОЕКТА"}/>
        <div className={classes.List}>
        {data.map((elem, i) => {
          return (
            <Cards
              customClass={classes.Item}
              customTitleClass={classes.CardsTitle}
              number={elem.number}
              title={elem.title}
              text={elem.text}
              key={i}
              />
          )
        })}
        </div>
        <Result/>
        <Thanks/>
        </div>
      </div>
    </section>
  )
}



export default FourStep;